import {Dexie} from 'dexie';
export interface Category {
  category_id: string;
  category_name: string;
}

export interface Livetv {
  category_id: string;
  epg_channel_id: string;
  // added: string;
  // custom_sid: string;
  // direct_source: string;
  // is_adult: string;
  name: string;
  stream_icon: string;
  stream_id: number;
  // num: number;
  // stream_type: string;
  // tv_archive: number;
  // tv_archive_duration: number;
}
export class LivetvdbService extends Dexie {
  categories: Dexie.Table<Category, string>;
  livetv: Dexie.Table<Livetv, number>;
      constructor() {
      super('LivetvDB');
      this.version(1).stores({
        categories: 'category_id',
        livetv: '++id, stream_id, category_id'
      });
  
      this.categories = this.table('categories');
      this.livetv = this.table('livetv');
    }
    
    

}



export const db = new LivetvdbService()
